export enum DomainStatusEnum {
    NOT_PROCESSED = "NotProcessed",
    SUCCESS = "Success",
    FAILURE = "Failure",
    SKIPPED = "Skipped",
    DOMAIN_NOT_FOUND = "NotFound",
    AUTO_RENEWED = "Auto-Renewed",
    CANCELLED = "Cancelled",
}
